'use strict';

var React = require('react');
var ClassNames = require('classnames');
var _ = require('lodash');
var FundingYourProductActions = require('../../actions/FundingYourProductActions.js');
var Validators = require('../../utils/Validators.js');
var Formatter = require('../../utils/Formatter.js');
//components
var TextInput = require('../Common/TextInput.jsx');
var RadioInput = require('../Common/RadioInput.jsx');
var CancelDoneButtons = require('../Common/CancelDoneButtons.jsx');
var InlineMessage = require('../Common/InlineMessage.jsx');
//constants
var FundingYourProductConstants = require('../../constants/FundingYourProductConstants.js');
var YesNoRadioData = require('../../constants/ApplicationConstants.js').YesNoRadioData;
var ProductIds = require('../../constants/ApplicationConstants.js').ProductIds;
var YesNoValues = require('../../constants/ApplicationConstants.js').YesNoValues;
var FundingYourProductStore = require('../../stores/FundingYourProductStore.js');
var FundingYourProductHelper = require('../../utils/FundingYourProductHelper.js');
var Formatter = require('../../utils/Formatter.js');

var InternalRolloverDetails = React.createClass({
    getInitialState: function () {
        return {
            showEnterLeaveAmount: FundingYourProductStore.showEnterLeaveAmount(),
            otherInvestmentOptionChecked: FundingYourProductStore.otherInvestmentOptionChecked()
        };
    },

    _onChange: function () {
        this.setState({
            showEnterLeaveAmount: FundingYourProductStore.showEnterLeaveAmount(),
            otherInvestmentOptionChecked: FundingYourProductStore.otherInvestmentOptionChecked()
        });
    },

    handleRolloverBalance: function (e) {
        this.updateStoreModel(e);
        this.setState({ showEnterLeaveAmount: (e.target.value === 'enterAmount' || e.target.value === 'leaveAmount') });
    },

    cancelInternalRollover: function (e) {
        this.props.onCancelClick(e);
    },

    submitInternalRollover: function (e) {
        this.props.onDoneClick(e);
    },

    updateStoreModel: function (event) {
        var fieldId = event.target.model;
        var fieldValue = event.target.value;
        this.updateRollover(fieldId, fieldValue);
    },

    updateRollover: function (model, value) {
        if (this.props.inSummary) {
            FundingYourProductActions.updateExistingRollover(model, value, FundingYourProductConstants.RollOverTypes.INTERNAL, this.props.index);
        } else {
            FundingYourProductActions.updateNewRollover(model, value, FundingYourProductConstants.RollOverTypes.INTERNAL);
        }
    },

    handleOtherInvestmentCheckbox: function (event) {
        var fieldId = event.target.name;
        var fieldValue = event.target.checked;
        this.updateRollover(fieldId, fieldValue);
    },

    handleRollOverAmountContextualMessageVisibility: function() {
        if (this.props.data.rollOverAmount
           && this.props.data.rollOverName
           && (this.props.data.partialRolloverType === FundingYourProductConstants.HowMuchToRollOver.LEAVE_AMOUNT || this.props.data.partialRolloverType === FundingYourProductConstants.HowMuchToRollOver.ENTER_AMOUNT)
           && Validators.currencyValidation(this.props.data.remainingBalance)
           && FundingYourProductHelper.validateAccountNumber(FundingYourProductConstants.RollOverTypes.INTERNAL, this.props.data.accountNumber)) {
            return Formatter.formatString(this.props.content.fundingYourProduct.enterLeaveAmountMessage, { product: this.props.data.rollOverName, accountNumber: this.props.data.accountNumber });
        }
        return '';
    },
    render: function () {
        var isSuper = _.find(FundingYourProductConstants.SuperProducts, { value: this.props.data.rollOverName });
        var showEntireBalanceDetails = this.props.showEntireBalanceDetails || isSuper;
        var rollOverAmountContextualMessage = this.handleRollOverAmountContextualMessageVisibility();
        var entireBalanceQuestionVisibility = (showEntireBalanceDetails && (this.props.product === ProductIds.SUPER) && (this.props.data.partialRolloverType === FundingYourProductConstants.HowMuchToRollOver.ENTIRE_BALANCE));
        var maxRolloverError = null;
        var isNumberOfRolloversValid = _.filter(this.props.data.errorList, { id: 'fypMaxRolloversError' });
        var investmentLabel = (this.props.product === ProductIds.INVESTMENT) ? 'How much would you like to transfer?' : 'How much would you like to rollover?';
        if (isNumberOfRolloversValid.length > 0 && isNumberOfRolloversValid[0]) {
            maxRolloverError =
                <InlineMessage id="fypMaxFundingSourcesError"
                               isHidden={!isNumberOfRolloversValid[0].message}
                               type={isNumberOfRolloversValid[0].type}
                               message={isNumberOfRolloversValid[0].message} />;
        }
        return (
            <div id="fypInternalRolloverDetails" className={ClassNames(this.props.className, { hidden: !this.props.showRolloverDetails })}>
                <RadioInput id="fypInternalRolloverOption"
                            label={investmentLabel}
                            model="partialRolloverType"
                            data={FundingYourProductConstants.InternalRolloverTypeData}
                            value={this.props.data.partialRolloverType}
                            onChange={this.handleRolloverBalance}
                            contextualMessage={this.props.data.partialRolloverType === FundingYourProductConstants.HowMuchToRollOver.ENTIRE_BALANCE ? this.props.content.fundingYourProduct.entireBalanceMessage : null}
                            isHidden={!this.props.showRolloverDetails}
                            errorList={this.props.data.errorList} />
                <RadioInput id="fypIsEntireBalance"
                            label="Would you like to transfer your existing insurance cover, if applicable?"
                            model="entireBalanceQuestion"
                            data={YesNoRadioData}
                            value={this.props.data.entireBalanceQuestion}
                            onChange={this.updateStoreModel}
                            contextualMessage={this.props.data.entireBalanceQuestion !== YesNoValues.YES ? this.props.content.fundingYourProduct.noInsuranceTransferMessage : null}
                            isHidden={!entireBalanceQuestionVisibility}
                            errorList={this.props.data.errorList} />
                <div className={ClassNames({ hidden: !this.state.showEnterLeaveAmount })}>
                    <div>
                        <TextInput id="fypInternalRolloverAmount"
                                   label="Amount"
                                   model="rollOverAmount"
                                   symbol="currency"
                                   value={this.props.data.rollOverAmount}
                                   onBlur={this.updateStoreModel}
                                   errorList={this.props.data.errorList}
                                   contextualMessage={rollOverAmountContextualMessage} />
                    </div>
                    <div className="other-investment">
                        <input id="fypOtherInvestmentOptionChecked" 
                               name="otherInvestmentOptionChecked" 
                               className="checkbox-investment" 
                               type="checkbox" 
                               checked={this.props.data.otherInvestmentOptionChecked} 
                               onChange={this.handleOtherInvestmentCheckbox} />
                        <h4>I want a different investment allocation as follows:</h4>
                    </div>
                    <div className="other-investment-input">
                        <TextInput id="fypOtherInvestmentOption"
                                   model="otherInvestmentOption"
                                   contextualMessage={this.props.content.fundingYourProduct.noInvestmentMessage}
                                   isDisabled={!this.props.data.otherInvestmentOptionChecked}
                                   value={this.props.data.otherInvestmentOption}
                                   onBlur={this.updateStoreModel} 
                                   errorList={this.props.data.errorList} />
                    </div>
                </div>
                <CancelDoneButtons id="internalRolloverFormButton"
                                   index={this.props.index}
                                   onClickCancel={this.cancelInternalRollover}
                                   onClickDone={this.submitInternalRollover} />
                {maxRolloverError}
            </div>
		);
    }
});

module.exports = InternalRolloverDetails;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/FundingYourProduct/InternalRolloverDetails.jsx